import { useTranslation } from 'react-i18next'
import { connectStats } from 'react-instantsearch-dom'
const Stats = ({
  nbHits,
}: {
  nbHits: any
  query: any
  lang: any
}) => {
  const { t } = useTranslation()
  return (
    <div className="CustomStats">
      {t('shown')}
      {':'} {nbHits} {t('items')}
    </div>
  )
}

const CustomStats = connectStats(Stats)
export default CustomStats
